import script from "./LazyImage.vue?vue&type=script&setup=true&lang=js"
export * from "./LazyImage.vue?vue&type=script&setup=true&lang=js"

import "./LazyImage.vue?vue&type=style&index=0&id=72c00e2d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72c00e2d"]])

export default __exports__